import request from '@/utils/request'


// 查询食谱计划列表
export function listPlan(query) {
  return request({
    url: '/cookbook/plan/list',
    method: 'get',
    params: query
  })
}

// 查询食谱计划分页
export function pagePlan(query) {
  return request({
    url: '/cookbook/plan/page',
    method: 'get',
    params: query
  })
}

// 查询食谱计划详细
export function getPlan(data) {
  return request({
    url: '/cookbook/plan/detail',
    method: 'get',
    params: data
  })
}

// 新增食谱计划
export function addPlan(data) {
  return request({
    url: '/cookbook/plan/add',
    method: 'post',
    data: data
  })
}

// 修改食谱计划
export function updatePlan(data) {
  return request({
    url: '/cookbook/plan/edit',
    method: 'post',
    data: data
  })
}

// 删除食谱计划
export function delPlan(data) {
  return request({
    url: '/cookbook/plan/delete',
    method: 'post',
    data: data
  })
}
